/**
 * Remove with predicate and mutate the array
 * @param array
 * @param predicate
 */
export function arrayRemove<T>(
    array: T[],
    predicate: (item: T, index: number) => boolean,
): void {
    for (let i = array.length - 1; i >= 0; i--) {
        if (predicate(array[i] as T, i)) {
            array.splice(i, 1);
        }
    }
}
